import { render, staticRenderFns } from "./xizaokaUpdate_settlement.vue?vue&type=template&id=4dd27dc4&scoped=true&"
import script from "./xizaokaUpdate_settlement.vue?vue&type=script&lang=js&"
export * from "./xizaokaUpdate_settlement.vue?vue&type=script&lang=js&"
import style0 from "./xizaokaUpdate_settlement.vue?vue&type=style&index=0&id=4dd27dc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd27dc4",
  null
  
)

export default component.exports